import { useEffect } from 'react'
import { LuArrowLeft, LuArrowUpRight, LuPrinter } from 'react-icons/lu'
import projects from '../data/projects'
import './CV.css'

const skillGroups = [
    {
        title: 'Development',
        skills: 'React, Next.js, TypeScript, JavaScript, PHP, Laravel, Python, C#, HTML, CSS',
    },
    {
        title: 'Platforms & tools',
        skills: 'AWS, Supabase, MySQL, Vercel, WordPress, Pantheon, DDEV, Unity, Tailwind CSS',
    },
    {
        title: 'Practice',
        skills: 'Full-stack development, UX/UI design, accessibility, educational technology, product design',
    },
]

const CV = () => {
    useEffect(() => {
        const previousTitle = document.title
        document.title = 'CV | Josephine Nguyen'
        return () => {
            document.title = previousTitle
        }
    }, [])

    return (
        <main id="main-content" className="cv-page">
            <div className="site-container cv-page__container">
                <div className="cv-page__topline">
                    <a className="cv-page__back" href="/#resume">
                        <LuArrowLeft aria-hidden="true" /> Back to portfolio
                    </a>
                    <button
                        className="cv-page__print"
                        type="button"
                        onClick={() => window.print()}
                    >
                        <LuPrinter aria-hidden="true" /> Print or save as PDF
                    </button>
                </div>

                <header className="cv-page__header">
                    <p className="eyebrow">Curriculum vitae</p>
                    <h1>Josephine Nguyen</h1>
                    <p className="cv-page__lead">
                        Full-stack developer, product designer, and educational
                        technologist building thoughtful tools for learning.
                    </p>
                    <div className="cv-page__contact">
                        <a href="mailto:the.josephine.nguyen@gmail.com">
                            Email <LuArrowUpRight aria-hidden="true" />
                        </a>
                        <a
                            href="https://github.com/josephine828"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            GitHub <LuArrowUpRight aria-hidden="true" />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/josephine-nguyen-software-engineer/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            LinkedIn <LuArrowUpRight aria-hidden="true" />
                        </a>
                    </div>
                </header>

                <section className="cv-section" aria-labelledby="cv-experience">
                    <h2 id="cv-experience">Experience</h2>
                    <div className="cv-entry cv-entry--featured">
                        <div className="cv-entry__heading">
                            <div>
                                <h3>Digital Product Developer &amp; Account Manager</h3>
                                <p>MicroSociety Inc.</p>
                            </div>
                            <span>2024 – Present</span>
                        </div>
                        <ul>
                            <li>
                                Blend software engineering, UX/UI design, and
                                curriculum thinking to create tools for students,
                                educators, and school communities.
                            </li>
                            <li>
                                Develop products including MicroSociety® 2.0 and
                                4th Terra® with feedback from classrooms and
                                consultants.
                            </li>
                            <li>
                                Work across educator platforms, interactive
                                learning experiences, and the organization's web
                                presence.
                            </li>
                        </ul>
                    </div>
                    <div className="cv-entry">
                        <h3>Earlier experience</h3>
                        <p>
                            My path includes a co-op and volunteer work with
                            MicroSociety, along with roles as a student mentor,
                            math tutor, and crime statistics analyst.
                        </p>
                    </div>
                </section>

                <section className="cv-section" aria-labelledby="cv-projects">
                    <div className="cv-section__heading">
                        <h2 id="cv-projects">Projects</h2>
                        <span>{projects.length} projects</span>
                    </div>
                    <div className="cv-projects">
                        {projects.map((project) => (
                            <article className="cv-project" key={project.title}>
                                <div className="cv-project__heading">
                                    <h3>{project.title}</h3>
                                    <span>{project.date}</span>
                                </div>
                                <p className="cv-project__category">
                                    {project.category}
                                </p>
                                <p>{project.desc}</p>
                                <p className="cv-project__tech">{project.tech}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <div className="cv-page__closing-grid">
                    <section className="cv-section" aria-labelledby="cv-education">
                        <h2 id="cv-education">Education &amp; recognition</h2>
                        <div className="cv-entry">
                            <h3>B.S. in Software Engineering</h3>
                            <p>
                                Drexel University · Minors in Human-Computer
                                Interaction and Linguistics · Summa Cum Laude
                            </p>
                        </div>
                        <div className="cv-entry">
                            <h3>Honors</h3>
                            <p>
                                National Math Championships and the NCWIT Award
                                for Aspirations in Computing.
                            </p>
                        </div>
                    </section>

                    <section className="cv-section" aria-labelledby="cv-skills">
                        <h2 id="cv-skills">Skills</h2>
                        {skillGroups.map(({ title, skills }) => (
                            <div className="cv-entry" key={title}>
                                <h3>{title}</h3>
                                <p>{skills}</p>
                            </div>
                        ))}
                    </section>
                </div>
            </div>
        </main>
    )
}

export default CV
